import { ergoProjectsConstants } from './constants';

export const initialState = {
  data: [],
  pending: false,
};

export function ergoProjects(state = initialState, action) {
  switch (action.type) {
    case ergoProjectsConstants.GET_ERGO_PROJECTS_REQUEST:
      return {
        ...initialState,
        pending: true,
      };
    case ergoProjectsConstants.GET_ERGO_PROJECTS_SUCCESS:
      return {
        ...state,
        data: action.data.ergoProjects,
        meta: action.data.meta,
        pending: false,
      };
    case ergoProjectsConstants.GET_ERGO_PROJECTS_FAILURE:
    default:
      return state;
  }
}
